import React, { useEffect, useState } from "react";
import { Table, Button, message,Space,Input, Row, Col } from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined,SearchOutlined } from "@ant-design/icons";
import SupplierForm from "./SupplierForm";
import API from "../../api";
import CustomTable from "../../components/Table/CustomTable";
import ConfirmationModal from "../../components/ConfirmationModal";
import { getUserRole } from "../../utils/auth";


export default function Supplier() {
  const [suppliers, setSuppliers] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [supplierToDelete, setSupplierToDelete] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
 const [paginationInfo, setPaginationInfo] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
  });
  const [loading, setLoading] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
    const [userRole, setUserRole] = useState("");
      
    
          useEffect(() => {
            setUserRole(getUserRole()); 
          }, []);
  

  const getSuppliers = async () => {
    try {
      setLoading(true)
      const { current, pageSize } = paginationInfo;

      const response = await API.get("/suppliers/paginate", { params: { page: current, limit: pageSize, search: searchQuery, } });
      const { suppliers:  getSuppliers, pagination } = response.data;
      setSuppliers(getSuppliers);
      setPaginationInfo((prev) => ({
        ...prev,
        total: pagination.total,
      }));
    } catch (err) {
      console.error("Error fetching suppliers:", err);
    }finally {
      setLoading(false)
    }

  };

  useEffect(() => {
    getSuppliers();
  }, [paginationInfo.current, paginationInfo.pageSize, searchQuery]);

 // Handle pagination changes
 const handlePaginationChange = (current, pageSize) => {
  setPaginationInfo({ ...paginationInfo, current, pageSize });
};

  
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPaginationInfo((prev) => ({ ...prev, current: 1 }));
  };


  const handleAddSupplier = (newSupplier) => {
    getSuppliers();
  };

  const handleEditSupplier = (updatedSupplier) => {
    getSuppliers();
  };

  const handleDeleteClick = (supplier) => {
    setSupplierToDelete(supplier);
    setIsDeleteModalVisible(true);
  };

  const handleDeleteSupplier = async () => {
    try {
      await API.delete(`/suppliers/${supplierToDelete._id}`);
      setSuppliers((prev) =>
        prev.filter((supplier) => supplier._id !== supplierToDelete._id)
      );
    } catch (err) {
      console.error("Error deleting supplier:", err);
      message.error(err.response.data.message);

    } finally {
      setIsDeleteModalVisible(false);
    }
  };

  const columns = [
    {
      title: "Index",
      key: "index",
      render: (_, __, index) =>
        (paginationInfo.current - 1) * paginationInfo.pageSize + index + 1,
    },
    {
      title: "Name",
      dataIndex: "name", // Correct case
      key: "name",
    },
    {
      title: "Phone",
      dataIndex: ["contactInfo", "phone"],
      key: "phone",
    },
    {
      title: "Email",
      dataIndex: ["contactInfo", "email"],
      key: "email",
    },
    {
      title: "GST Number",
      dataIndex: "gstNumber",
      key: "gstNumber",
    },
    {
      title: "PAN Number",
      dataIndex: "panNumber",
      key: "panNumber",
    },
    {
      title: "Address",
      dataIndex: ["contactInfo", "address"],
      key: "address",
      render: (address) => {
        if (!address) return "N/A"; // Handle missing address
        const { street, city, state, pincode } = address;
        return `${street || ""}, ${city || ""}, ${state || ""} - ${pincode || ""}`.trim();
      },
    },

    userRole.editPermission == true &&{
      title: "Actions",
      key: "actions",
      align: "center",
      render: (record) => (
        <div>
          <Button
            icon={<EditOutlined />}
            onClick={() => {
              setIsEdit(true);
              setSelectedSupplier(record);
              setOpenDrawer(true);
            }}
          />

          {/* <Button
            danger
            icon={<DeleteOutlined />}
            style={{ marginLeft: 8 }}
            onClick={() => handleDeleteClick(record)}
          /> */}
        </div>
      ),
    },
  ];

  return (
    <div  style={{
      padding: "20px",
      background: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
    }}>
    {/* Header Section */}
    <Row gutter={[16, 16]} style={{ marginBottom: 16, padding: '10px 20px',justifyContent: 'flex-end'  }}>
      <Col xs={24} sm={12} md={6}>
      <Space style={{ width: '100%' , justifyContent: 'flex-end' }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setSelectedSupplier(null);
            setIsEdit(false);
            setOpenDrawer(true);
          }}
          block // Ensures the button is full-width on smaller screens
          >
          Add New Supplier
        </Button>
    
        <Input
          placeholder="Search suppliers"
          prefix={<SearchOutlined />}
          value={searchQuery}
          onChange={handleSearch}
          style={{ width: '100%' }}
          />
          </Space>
      </Col>
          
    </Row>

    {
      openDrawer &&
      <SupplierForm
      open={openDrawer}
      setOpen={setOpenDrawer}
      selectedSupplier={selectedSupplier}
      onEdit={isEdit ? handleEditSupplier : handleAddSupplier}
      />
    }

    
    <CustomTable
      columns={columns}
      dataSource={suppliers}
      onPaginationChange={(pagination) => {
        setPaginationInfo({
          current: pagination.current,
          pageSize: pagination.pageSize,
        });
      }}
      loading={loading}
      style={{ padding: '0 20px' }}
      total={paginationInfo.total}
    />

    {/* Confirmation Modal */}
    <ConfirmationModal
      visible={isDeleteModalVisible}
      onConfirm={handleDeleteSupplier}
      onCancel={() => setIsDeleteModalVisible(false)}
      title="Confirm Deletion"
      content="Are you sure you want to delete this supplier? This action cannot be undone."
    />
  </div>
  );
}
